import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import {
  INumberInputFieldConfigurationClient,
  INumberInputFieldConfigurationServer,
} from "./interface";
import { validateRule } from "../FormTextInputField/rules/utils";

export const transformNumberInputFieldConfigClientToServer = (
  fieldConfigClient: INumberInputFieldConfigurationClient
): INumberInputFieldConfigurationServer => {
  const {
    placeholder,
    initialValue,
    maxNumberAllowed,
    fromNumberFieldId,
    toNumberFieldId,
    minNumberAllowed,
    isNegativeAllowed,
    isDecimal,
    decimal,
    writeJavascript,
    isIncrDecrEnabled,
    isRoundedNumber,
    maskedField,
    incrDecrType,
    initialValueWithAccessKey,
    lookupFilter,
    isSubmissionCount,
    submissionCountForm,
  } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    maxNumberAllowed: maxNumberAllowed,
    minNumberAllowed: minNumberAllowed,
    fromNumberFieldId: fromNumberFieldId,
    toNumberFieldId: toNumberFieldId,
    isNegativeAllowed: isNegativeAllowed,
    isDecimal: isDecimal,
    writeJavascript: writeJavascript,
    decimal: { selected: decimal + "" },
    isRoundedNumber: isRoundedNumber,
    isIncrDecrEnabled: isIncrDecrEnabled,
    maskedField: {
      isMaskingEnabled: maskedField?.isMaskingEnabled,
      maskChar: maskedField?.maskChar,
      maxCharacter: maskedField?.maxCharacter,
      maskedIndexes: maskedField?.maskedIndexes,
    },
    incrDecrType: incrDecrType,
    initialValueWithAccessKey: initialValueWithAccessKey,
    lookupFilter: lookupFilter,
    isSubmissionCount: isSubmissionCount,
    submissionCountForm: submissionCountForm,
  };
  return fieldConfigServer;
};

export const transformNumberInputConfigServerToClient = (
  fieldConfigServer: INumberInputFieldConfigurationServer
): INumberInputFieldConfigurationClient => {
  const {
    placeHolder,
    initialValue,
    maxNumberAllowed,
    minNumberAllowed,
    fromNumberFieldId,
    toNumberFieldId,
    isNegativeAllowed,
    isDecimal,
    decimal,
    writeJavascript,
    isIncrDecrEnabled,
    isRoundedNumber,
    maskedField,
    incrDecrType,
    initialValueWithAccessKey,
    lookupFilter,
    isSubmissionCount,
    submissionCountForm,
  } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    maxNumberAllowed: maxNumberAllowed,
    minNumberAllowed: minNumberAllowed,
    fromNumberFieldId: fromNumberFieldId,
    toNumberFieldId: toNumberFieldId,
    isNegativeAllowed: isNegativeAllowed,
    isDecimal: isDecimal,
    decimal: parseInt(decimal?.selected),
    writeJavascript: writeJavascript,
    isIncrDecrEnabled: isIncrDecrEnabled,
    isRoundedNumber: isRoundedNumber,
    maskedField: {
      isMaskingEnabled: maskedField?.isMaskingEnabled,
      maskChar: maskedField?.maskChar,
      maxCharacter: maskedField?.maxCharacter,
      maskedIndexes: maskedField?.maskedIndexes,
    },
    incrDecrType: incrDecrType,
    initialValueWithAccessKey: initialValueWithAccessKey,
    lookupFilter: lookupFilter,
    isSubmissionCount: isSubmissionCount,
    submissionCountForm: submissionCountForm,
  };
  return fieldConfigClient;
};

export const validateNumberInputFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const submissionValue =
    fieldSubmissionValue?.value !== undefined &&
      fieldSubmissionValue?.value !== null
      ? fieldSubmissionValue.value
      : "";

  if (fieldRules && submissionValue) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );
      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  if (isRequired) {
    if (
      submissionValue === null ||
      submissionValue === undefined ||
      submissionValue === ""
    ) {
      return [false, "Value is required"];
    }
  }
  return [true, ""];
};
